import { Components, Theme } from '@mui/material/styles';

export default function Link({ palette }: Theme): Components {
  return {
    MuiLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            color: palette.secondary.dark,
          },
        },
      },
    },
  };
}
